define('plugin/paid-events/collection/PaymentSystemCollection',['require','lib/collection/FilterableCollection','plugin/paid-events/model/PaymentSystemModel'],function (require) {

    var FilterableCollection = require('lib/collection/FilterableCollection');
    var PaymentSystemModel = require('plugin/paid-events/model/PaymentSystemModel');

    /**
     * Payment systems collection
     *
     * @class PaymentSystemCollection
     */
    return FilterableCollection.extend({

        url: '/ext/payment/payment-systems/',
        model: PaymentSystemModel,
        comparator: function (a, b) {
            if (b.get('id') === 'delay') {
                return -1;
            }
            return 1;
        },

        setSelected: function (id) {
            this.each(function (model) {
                if (model.get('selected') && model.get('id') !== id) {
                    model.set('selected', false);
                }
                if (model.get('id') === id) {
                    model.set('selected', true);
                }
            });
        }

    });

});
